<template>
  <div class="edit-catalog">
    <div class="catalog-content">
      <div class="edit-catalog-container" v-show="isVisible">
        <div class="edit-catalog-content">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :show-message="true">
            <el-form-item prop="title" label="目录" :label-width="formLabelWidth">
              <!-- <el-input v-model="ruleForm.title" maxlength="30" size="small"></el-input> -->
              <el-input v-model="ruleForm.title" size="small"></el-input>
            </el-form-item>
            <el-form-item prop="page" label="页码" :label-width="formLabelWidth">
              <el-input class="fd-no-number" v-model.number="ruleForm.page" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" type="number" size="small"></el-input>
            </el-form-item>
            <template v-if="!isPaper">
              <div class="el-form-item is-required" :label-width="formLabelWidth">
                <label class="el-form-item__label">书签</label>
                <div class="el-form-item__content">
                  <el-radio v-model="showBookmark" @change="showBookmarkHandler" :label="1">显示</el-radio>
                  <el-radio v-model="showBookmark" :label="0">不显示</el-radio>
                </div>
              </div>
              <div class="el-form-item is-required" :label-width="formLabelWidth">
                <label class="el-form-item__label">名称</label>
                <div class="el-form-item__content" style="margin-left: 50px">
                  <el-radio v-model="bookmarkLabelStr" :label="0">目录名</el-radio>
                  <el-radio v-model="bookmarkLabelStr" :label="1">自定义</el-radio>
                  <el-input v-model="bookmarkLabel" @input="handleInput" :maxlength="10" :disabled="!bookmarkLabelStr"></el-input>
                </div>
              </div>
            </template>
          </el-form>
          <div class="edit-btn-wrapper">
            <div class="edit-catalog-btn" @click="clickHandler(editType)">保存</div>
            <div class="edit-catalog-btn edit-catalog-btncancel" @click="clickHandler('cancel')">取消</div>
          </div>
        </div>
      </div>
      <el-scrollbar ref="editCatalogScrollbar" class="catalog-content-scrollbar">
        <div class="one-click-catalog">
          <span>{{ oneClickCatalogMsg }}</span>
          <i class="vip">VIP</i>
          <!-- <img src="@imgs/vip-function.png" alt="" class="vip-func" /> -->
          <el-button
            class="start-update-catelog"
            :class="{ merge: merge === 1 }"
            size="mini"
            @click="updateCatalog"
            :disabled="oneClickCatalogMsg == UpdateCatIng || merge === 1 || (this.isPaper && this.readModel === 2) ? true : false"
            >开始</el-button
          >
          <img src="@imgs/repeal.png" alt="" @click="repealShow" v-show="showRepealLock" />
        </div>
        <div class="fd-addcatalog-btn" v-show="!catalogList || !catalogList.length" @click="clickEdit('peer')">
          <span>添加目录</span>
          <img src="@imgs/icon_add.png" />
        </div>
        <el-tree
          :data="catalogList"
          draggable
          default-expand-all
          :expand-on-click-node="false"
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
          @node-click="nodeClick"
          @node-drop="handleDragSuccess"
          @node-drag-start="handleDragStart"
          @node-drag-end="handleDragEnd"
          :filter-node-method="filterNode"
        >
          <div class="custom-tree-node" :title="node.label" slot-scope="{ node, data }">
            <div class="label-wrapper">
              <!-- draggable="false" 解决el-tree中的图片不能拖拽 -->
              <img draggable="false" src="@imgs/catalog.png" />
              <div class="slot-label">{{ node.label }}</div>
            </div>
            <div class="fd-edit-btns" v-if="editId === data.id">
              <img class="fd-edit-btnadd" src="@imgs/icon_add.png" @click.stop="clickAdd" />
              <img class="fd-edit-btnedit" src="@imgs/icon_edit.png" @click.stop="clickEdit('edit')" v-show="isShow" />
              <img class="fd-edit-btndelete" src="@imgs/icon_delete.png" @click.stop="clickEdit('remove')" v-show="isShow" />
              <span class="fd-edit-btnpeer" v-show="!isShow" @click.stop="clickEdit('peer')">同级</span>
              <span class="fd-edit-btnsub" v-show="!isShow" @click.stop="clickEdit('sub')">子级</span>
            </div>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <TipCatalog ref="updateCatalogue" :tipText="updateTip" @tipSure="handleClickUpdate"></TipCatalog>
    <TipCatalog ref="repealCatalogue" :tipText="repeal" @tipSure="repealCata"></TipCatalog>
  </div>
</template>
<script>
import TipDialog from '@components/common/TipDialog.vue'
import TipCatalog from './catalogTip.vue'
import api from '@api/getBook.js'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  data() {
    var checkPage = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error('不能为空'))
      } else if (value < 1) {
        callback(new Error('需大于0'))
      } else if (value > this.totalPage) {
        callback(new Error('需小于总页数' + this.totalPage))
      } else {
        callback()
      }
    }
    return {
      editId: '',
      isShow: true,
      isVisible: false,
      editType: '',
      isChooseFlag: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      ruleForm: {
        title: '',
        page: ''
      },
      rules: {
        title: [{ required: true, message: '不能为空' }],
        page: [{ required: true, validator: checkPage }]
      },
      formLabelWidth: '50px',
      currentNode: { data: '', _this: '', component: '' },
      oneClickCatalogMsg: '一键生成目录',
      UpdateCatIng: '正在更新目录...',
      dialogVisible: false,
      updateTip: '一键生成目录后将替换现有目录，确定替换？',
      repeal: '将恢复至系统自动提取之前最后保存的手工目录结构，确认恢复？',
      showRepealLock: false,
      showBookmark: 0,
      bookmarkLabelStr: 0,
      bookmarkLabel: '',
      bookmarkId: ''
    }
  },
  mixins: [compareVipRight],
  computed: {
    catalogId: {
      get: function() {
        return this.$store.state.config.bookObj.catalogId
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_CATALOG_ID', value)
      }
    },
    catalogList: {
      get: function() {
        return this.$store.state.config.bookObj.catalogList
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_CATALOG_LIST', value)
      }
    },
    bookmarkList: {
      get: function() {
        console.log(this.$store.state.book.bookmarkList)
        return this.$store.state.book.bookmarkList
      },
      set: function(value) {
        this.$store.commit('book/UPDATE_BOOKMARK_LIST', value)
      }
    },
    totalPage() {
      return this.$store.state.book.totalPage
    },
    isZoom() {
      return this.$store.state.book.isZoom
    },
    isPaper() {
      return this.$store.state.book.isPaper
    },
    readModel() {
      return this.$store.state.book.readModel
    },
    merge() {
      return this.$store.state.config.bookObj.merge
    },
    bookObj() {
      return this.$store.state.config.bookObj
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  mounted() {
    //动态设置目录编辑栏目的整体高度，目前没有找到css方法可自动实现,计算的值跟使用calc有关，有延迟和误差
    this.$nextTick(() => {
      let height = $('.edit-content').height() - 280
      $('.catalog-content-scrollbar').css('height', height < 110 ? 80 : height + 'px')
      // 撤销按钮
      this.isShowRepeal()
    })
    // setTimeout(() => {}, 4000)
  },
  methods: {
    clickAdd(data) {
      this.isShow = !this.isShow
    },
    clickEdit(type) {
      if (type === 'remove') {
        this.isVisible = false
        return this.remove()
      }
      if (type === 'peer' || type === 'sub') {
        this.ruleForm.title = '编辑目录内容'
        this.ruleForm.page = '1'
        this.bookmarkId = ''
        this.bookmarkLabel = ''
        this.bookmarkLabelStr = 0
        this.showBookmark = 0
      }
      this.isVisible = true
      this.editType = type
    },
    handleDragStart() {
      this.editId = ''
      $('div[role="treeitem"]').addClass('fd-darg-position')
    },
    handleDragSuccess(currentNode) {
      this.editId = ''
    },
    handleDragEnd() {
      $('div[role="treeitem"]').removeClass('fd-darg-position')
    },
    nodeClick(data, _this) {
      this.isShow = true
      this.editId = data.id
      this.isChooseFlag = true
      this.currentNode = { data, _this }
      //选中时单向回显数据到输入框
      this.ruleForm.title = data.label
      this.ruleForm.page = data.page
      if (data.bookmarkId) {
        this.bookmarkId = data.bookmarkId
        for (let i = 0; i < this.bookmarkList.length; i++) {
          if (this.bookmarkList[i].id === this.bookmarkId) {
            this.bookmarkLabel = this.bookmarkList[i].label
            this.bookmarkLabelStr = this.bookmarkList[i].labelSrc
            this.showBookmark = this.bookmarkList[i].display
            break
          }
        }
      } else {
        this.bookmarkId = ''
        this.bookmarkLabel = ''
        this.bookmarkLabelStr = 0
        this.showBookmark = 0
      }
    },
    handleInput() {
      // 计算当前输入的字节长度
      let byteLength = 0
      for (let i = 0; i < this.bookmarkLabel.length; i++) {
        const charCode = this.bookmarkLabel.charCodeAt(i)
        // 判断字符是否为单字节或者双字节
        byteLength += charCode >= 0 && charCode <= 255 ? 1 : 2
        if (byteLength > 10) {
          // 如果超出最大字节长度，截取到正确的位置
          this.bookmarkLabel = this.bookmarkLabel.substring(0, i)
          break
        }
      }
    },
    clickHandler(methodName) {
      if (methodName === 'cancel') {
        this.isVisible = false
        this.ruleForm.title = this.currentNode.data.label
        this.ruleForm.page = this.currentNode.data.page
        this.bookmarkId = ''
        this.bookmarkLabel = ''
        this.bookmarkLabelStr = 0
        this.showBookmark = 0
        return
      }
      this.check().then(
        (resolve) => {
          if (methodName !== 'remove' && this.showBookmark) {
            this.saveBookmark(() => {
              this[methodName].call(this)
              this.$emit('saveCatalog')
            })
          } else {
            this[methodName].call(this)
          }
          if (!this.showBookmark && this.bookmarkId) {
            this.deleteBookmark(this.bookmarkId)
          }
          this.isVisible = false
        },
        (reject) => {}
      )
    },
    peer() {
      let currentId = ++this.catalogId
      const newChild = { id: currentId, label: this.ruleForm.title, page: this.ruleForm.page, children: [] }
      if (this.bookmarkId) {
        newChild.bookmarkId = this.bookmarkId
      }
      if (this.catalogList && this.catalogList.length > 0) {
        if (this.isChooseCatalog()) {
          let node = this.currentNode._this.parent
          let data = node.data
          if (!node.data.children) {
            node.data.push(newChild)
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(currentId)
              this.$nextTick(() => {
                document.querySelector('.el-tree .is-current').click()
                this.scroll()
              })
            })
          } else {
            node.data.children.push(newChild)
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(currentId)
              this.$nextTick(() => {
                document.querySelector('.el-tree .is-current').click()
                this.scroll()
              })
            })
          }
        }
      } else {
        this.catalogList = []
        this.catalogList.push(newChild)
      }
    },
    sub() {
      if (this.isChooseCatalog()) {
        let data = this.currentNode.data
        let currentId = ++this.catalogId
        const newChild = { id: currentId, label: this.ruleForm.title, page: this.ruleForm.page, children: [] }
        if (this.bookmarkId) {
          newChild.bookmarkId = this.bookmarkId
        }
        if (!this.currentNode.data.children) {
          this.$set(this.currentNode.data, 'children', [])
        }
        this.currentNode.data.children.push(newChild)
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(currentId)
          this.$nextTick(() => {
            document.querySelector('.el-tree .is-current').click()
            this.scroll()
          })
        })
      }
    },
    edit() {
      if (this.isChooseCatalog()) {
        this.currentNode.data.label = this.ruleForm.title
        this.currentNode.data.page = this.ruleForm.page
        if (this.bookmarkId) {
          this.currentNode.data.bookmarkId = this.bookmarkId
        }
      }
    },
    remove() {
      if (this.isChooseCatalog()) {
        let parent = this.currentNode._this.parent
        let data = this.currentNode.data
        let children = parent.data.children || parent.data
        let index = children.findIndex((d) => d.id === data.id)
        children.splice(index, 1)
        this.isChooseFlag = false
        this.editId = ''
        if (this.bookmarkId || data.bookmarkId) {
          this.deleteBookmark(this.bookmarkId || data.bookmarkId)
        }
      }
    },
    saveBookmark(callback) {
      // 保存书签
      let param = {
        catalogLabel: this.ruleForm.title,
        label: this.bookmarkLabel,
        pageNo: this.ruleForm.page,
        display: 1,
        labelSrc: this.bookmarkLabelStr,
        ebookId: this.bookObj.id,
        catalogId: this.currentNode.id
      }
      if (this.bookmarkId) {
        param.id = this.bookmarkId
      }
      api.setBookMark(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.bookmarkId = res.data.data.id
          this.getBookmarkList()
          callback && callback()
        }
      })
    },
    deleteBookmark(id) {
      api.delBookMarkById(id).then(() => {
        this.bookmarkId = ''
        this.bookmarkLabel = ''
        this.bookmarkLabelStr = 0
        this.showBookmark = 0
        this.getBookmarkList()
      })
    },
    // 获取书签
    getBookmarkList() {
      api.findBookMarkList(this.bookObj.id).then((res) => {
        if (res?.data.status === 0) {
          this.bookmarkList = res.data.data || []
          console.log(this.bookmarkList)
        }
      })
    },
    showBookmarkHandler() {
      if (this.bookmarkList.length >= 10) {
        this.$alert('最多只能添加10个书签', '提示', {})
        this.showBookmark = 0
      }
    },
    isChooseCatalog() {
      if (this.isChooseFlag) {
        return true
      } else {
        this.$alert('请选择一条目录', '提示', {
          confirmButtonText: '确定'
        })
        return false
      }
    },
    check() {
      return this.$refs.ruleForm.validate()
    },
    scroll() {
      if (document.querySelector('.el-tree .is-current').offsetTop > document.querySelector('.catalog-content-scrollbar').offsetHeight + this.$refs['editCatalogScrollbar'].wrap.scrollTop - 50) {
        this.$refs['editCatalogScrollbar'].wrap.scrollTop = document.querySelector('.el-tree .is-current').offsetTop - 50
      }
    },
    async updateCatalog() {
      if (await this.compareRight({ type: 'boole', key: 'autoCatalog' })) {
        this.$refs.updateCatalogue.dialogVisible = true
      } else {
        this.$refs.memberDialog.visible = true
      }
    },
    repealShow() {
      this.$refs.repealCatalogue.dialogVisible = true
    },
    handleClickUpdate() {
      //根据报刊类型不同调用不不同的API
      let updateCatalog = null
      if (this.isPaper) {
        if (parseInt(this.readModel) === 0) {
          updateCatalog = api.useEpaperSelfCatalog
        } else {
          //目前文件包类型的数字报暂不支持一键获取目录
          return
        }
      } else {
        updateCatalog = api.generationCatalog
      }
      //一键获取目录
      this.oneClickCatalogMsg = '正在更新目录...'
      const params = {
        id: this.bookObj.id
      }
      updateCatalog(params).then((res) => {
        const data = res.data
        this.oneClickCatalogMsg = '一键生成目录'
        if (data.code == 0 || data.status == 0) {
          if (data.data) {
            const catalogObj = JSON.parse(data.data) || {}
            console.log(JSON.parse(data.data))
            this.catalogList = catalogObj.catalogList
            this.catalogId = catalogObj.catalogId
          } else {
            this.catalogList = []
            this.catalogId = 0
          }
          api.delBookMarkByEbookId(this.bookObj.id).then((res) => {
            if (res.data.status === 0) {
              this.bookmarkList = []
            }
          })
          this.$message({
            type: 'success',
            message: '目录更新完成'
          })
          this.isShowRepeal()
        }
      })
    },
    repealCata() {
      const params = {
        id: this.bookObj.id
      }
      if (this.isPaper) {
        if (parseInt(this.readModel) === 0) {
          api.epaperRepealCatalog(params).then((res) => {
            const data = res.data
            if (data.status == 0) {
              if (data.data) {
                const catalogObj = JSON.parse(data.data) || {}
                this.catalogList = catalogObj.catalogList
                this.catalogId = catalogObj.catalogId
              } else {
                this.catalogList = []
                this.catalogId = 0
              }
              this.isShowRepeal()
            }
          })
        }
      } else {
        api.repealCatalog(params).then((res) => {
          const data = res.data
          if (data.code == 0) {
            if (data.data) {
              const catalogObj = JSON.parse(data.data) || {}
              this.catalogList = catalogObj.catalogList
              this.catalogId = catalogObj.catalogId
            } else {
              this.catalogList = []
              this.catalogId = 0
            }
            this.isShowRepeal()
          }
        })
      }
    },
    isShowRepeal() {
      const params = {
        id: this.bookObj.id
      }
      if (this.isPaper) {
        if (parseInt(this.readModel) === 0) {
          api.epaperRepealBtn(params).then((res) => {
            const data = res.data
            if (data.status == 0) {
              if (data.data) {
                this.showRepealLock = true
              } else {
                this.showRepealLock = false
              }
            }
          })
        }
      } else {
        api.repealBtn(params).then((res) => {
          const data = res.data
          if (data.code == 0) {
            if (data.data) {
              this.showRepealLock = true
            } else {
              this.showRepealLock = false
            }
          }
        })
      }
    },
    filterNode(value, data) {
      console.log(data, this.catalogList.length)
      let res = true
      if (data.children) {
        if (data.revokeStatus === 1) {
          res = false
        }
      } else {
        this.catalogList.forEach((element) => {
          if (element.revokeStatus === 1) {
            element.children.forEach((child) => {
              if (child.xiaoYangId === data.xiaoYangId) {
                res = false
                // return false
              }
            })
          } else {
            // return false
          }
        })
      }
      console.log(res)
      return res
    },
    treeFilter() {
      this.$refs.tree.filter()
    }
  },
  watch: {
    catalogList() {
      console.log('changed')
    }
  },
  components: {
    TipDialog,
    TipCatalog
  }
}
</script>
<style lang="scss">
.edit-catalog {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  .catalog-content {
    flex: 1;
    .el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
    .el-tree > .el-tree-node > .el-tree-node__content {
      font-weight: bolder;
    }
  }

  .edit-catalog-content {
    position: absolute;
    left: 260px;
    top: 50%;
    z-index: 9;
    transform: translateY(-50%);
    padding: 10px;
    border: 1px solid #f2f2f2;
    margin: 10px 20px 0 20px;
    background: #fff;
    .el-form {
      width: 250px;
    }
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        white-space: nowrap;
      }
      .el-form-item__content {
        margin-bottom: 10px;
        .el-form-item__error {
          white-space: nowrap;
          padding-top: 0px !important;
        }
      }
    }
    .el-input {
      .el-input__inner {
        height: 28px;
      }
    }
    .edit-btn-wrapper {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .edit-catalog-btn {
        width: 40%;
        height: 24px;
        text-align: center;
        background-color: #df5813;
        color: #fff;
        line-height: 24px;
        margin-top: 4px;
        cursor: pointer;
        &.remove {
          background-color: #999;
        }
        &.edit-catalog-btncancel {
          background-color: #999;
        }
      }
    }
  }
  .el-tree {
    padding: 0;
    .el-tree-node {
      white-space: nowrap !important;
    }
    .el-tree-node__expand-icon {
      // 解决禁用展开收起
      visibility: hidden;
      padding: 6px 0;
      &::before {
        opacity: 0;
      }
    }
    .el-tree-node__label {
      text-indent: 20px;
    }
    .custom-tree-node {
      // padding-left: 20px;
      display: inline-flex;
      justify-content: space-between;
      width: calc(100% - 12px);
      .label-wrapper {
        display: flex;
        align-items: center;
        flex: 1;
        width: calc(100% - 77px);
        img {
          // 暂时不显示，因还未实现拖动调整目录
          // display: none;
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
        .slot-label {
          width: calc(100% - 20px);
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .slot-page {
        margin-right: 20px;
      }
    }
  }
  .el-dialog__wrapper {
    text-align: center;
    white-space: nowrap;
    overflow: auto;
    &:after {
      content: '';
      display: inline-block;
      vertical-align: middle;
      height: 100%;
    }
    .el-dialog {
      margin: 30px auto !important;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      white-space: normal;
    }
  }
}
.edit-catalog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-textarea__inner {
    border-color: #dcdfe6 !important;
  }
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #df5813 !important;
  }
}
.fd-edit-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 3px;
    &.fd-edit-btndelete {
      margin-right: 10px;
    }
  }
  span {
    transform: scale(0.9);
    font-size: 14px;
    line-height: 16px;
    margin-right: 3px;
    color: #df5813;
    border: 1px solid #df5813;
    &.fd-edit-btnsub {
      margin-right: 10px;
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: none;
}
.catalog-content-scrollbar {
  .fd-addcatalog-btn {
    color: #df5813;
    text-align: center;
    cursor: pointer;
    img {
      vertical-align: middle;
    }
  }
  .is-horizontal {
    display: none;
  }
  .el-tree__empty-text {
    display: none;
  }
  .one-click-catalog {
    padding-left: 13px;
    padding-bottom: 10px;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    > span {
      // margin-right: 10px;
      display: inline-block;
      height: 20px;
      line-height: 20px;
    }
    .start-update-catelog {
      width: 70px;
      color: #fff;
      background: #df5813;
      padding-top: 4px;
      padding-bottom: 4px;
      border: none;
      margin-left: 8px;
      &.merge {
        background: #cecece;
      }
    }
    .is-disabled {
      background: #cecece;
      &:hover {
        color: #ffffff;
        background: #cecece;
      }
    }
    img {
      width: 15px;
      margin-left: 8px;
      cursor: pointer;
    }
    .vip-func {
      height: 20px;
      width: 20px;
      margin-left: 2px;
    }
    i {
      width: 30px;
      line-height: 20px;
      background: #df5813;
      text-align: center;
      color: #fff;
      font-size: 10px;
      margin-left: 5px;
      border-radius: 2px;
      font-style: normal;
      font-weight: bold;
    }
  }
}
.fd-darg-position {
  position: relative;
  z-index: 99999;
}
.fd-no-number input {
  appearance: textfield;
}
</style>
